/**
 * @module The Free Movie Countdown
 *
 * @import {Movie} from '../../moviePool/model/movie';
 * @import {NOVA_TIMER} from '../../layout/element/timer';
 */

import {AttributeSetup, AttributeLink} from '@acng/frontend-stargazer';
import {createMap, set, get} from '@acng/frontend-bounty/collection.js';
import {each} from '@acng/frontend-bounty/std/array.js';
import {set as attr} from '@acng/frontend-bounty/dom/attribute.js';
import {GlobalWatch, WatchGroup} from '@acng/frontend-relativity';

import {ctxMovie} from '../../moviePool/context/movie.js';
import {TIMING_END, TIMING_START} from '../../layout/attribute/index.js';
import {compile} from '../service/template.js';
import {ctxFreeMovieList} from '../context/list.js';
import {iso} from '@acng/frontend-bounty/std/date.js';

/**
 * Set up a {@link NOVA_TIMER | timer element} to display a countdown to the time
 * when the {@link ctxMovie | local movie} will be free.
 *
 * @example
 *
 * ```html
 * <nova-timer fmotd-countdown>${ timeLeft }</nova-timer>
 * ```
 *
 * @group DOM Attribute
 */
export const FMOTD_COUNTDOWN = 'fmotd-countdown';

AttributeSetup(FMOTD_COUNTDOWN, (name) => {
  /**
   * Cache the timing for each freemovie globally, to avoid having to iterate
   * every time. The cache is filled with ISO date string for improved
   * readability when inspecting DOM.
   *
   * @type {Map<Movie['id'], string>}
   */
  const timings = createMap();
  const watch = WatchGroup(`[${name}]`, ctxMovie, ctxFreeMovieList);

  GlobalWatch(ctxFreeMovieList)((list) => each(list, (item) => set(timings, item.id, iso(item.free_since))));

  AttributeLink(name, (element) =>
    watch(element, (element, [movie]) => {
      attr(element, TIMING_START, '0');
      attr(element, TIMING_END, get(timings, movie.id));
      //attr(element, TIMING_END, `${Date.now() + 30000000}`); // Test countdown
    }),
  );

  return compile;
});
